import { render, staticRenderFns } from "./Item0.vue?vue&type=template&id=b541fbb4&scoped=true"
import script from "./Item0.vue?vue&type=script&lang=js"
export * from "./Item0.vue?vue&type=script&lang=js"
import style0 from "./Item0.vue?vue&type=style&index=0&id=b541fbb4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b541fbb4",
  null
  
)

export default component.exports